export default {"src":"/_next/static/media/trustpilotStar.dbac3bf2.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};